function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isNil from 'lodash/isNil';
import map from 'lodash/map';
import { mapState, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  components: {
    Multiselect: Multiselect
  },
  computed: _objectSpread({}, mapState({
    groups: function groups(s) {
      return s.groups.groups;
    }
  }), {}, mapGetters('api', {
    resultType: 'formResultType'
  }), {}, mapGetters('groups', {
    options: 'options'
  }), {
    disabled: function disabled() {
      return isNil(this.$ncsConfig.result[this.resultType].grouping) || this.options.length === 1;
    },
    selected: {
      get: function get() {
        return map(this.groups, function (name) {
          return {
            name: name
          };
        });
      },
      set: function set(v) {
        this.$store.dispatch('groups/setGroups', map(v, 'name'));
      }
    },
    label: function label() {
      return this.$t("groups.selector.label");
    },
    multiselectOptions: function multiselectOptions() {
      var _this = this;

      return map(this.options, function (name) {
        return {
          name: name,
          $isDisabled: _this.selected.length === 0 && name === 'unit'
        };
      });
    }
  }),
  methods: {
    i18nOption: function i18nOption(option) {
      return this.$t("groups.selector.options.".concat(option.name || option));
    },
    onRemove: function onRemove(option) {
      if (this.selected.length === 1 && this.selected[0] === option) {
        this.$refs.multiselect.activate();
      }
    },
    onClose: function onClose() {
      if (this.selected.length === 0) {
        this.$store.dispatch('groups/setDefault');
      }
    }
  }
};